/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateJSONWebKeySetForm,
  CreateJSONWebKeySetForm$Outbound,
  CreateJSONWebKeySetForm$outboundSchema,
} from "../components/createjsonwebkeysetform.js";

export type CreateJsonWebKeySetSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateJsonWebKeySetRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createJSONWebKeySetForm: CreateJSONWebKeySetForm;
};

/** @internal */
export type CreateJsonWebKeySetSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateJsonWebKeySetSecurity$outboundSchema: z.ZodMiniType<
  CreateJsonWebKeySetSecurity$Outbound,
  CreateJsonWebKeySetSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createJsonWebKeySetSecurityToJSON(
  createJsonWebKeySetSecurity: CreateJsonWebKeySetSecurity,
): string {
  return JSON.stringify(
    CreateJsonWebKeySetSecurity$outboundSchema.parse(
      createJsonWebKeySetSecurity,
    ),
  );
}

/** @internal */
export type CreateJsonWebKeySetRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateJSONWebKeySetForm: CreateJSONWebKeySetForm$Outbound;
};

/** @internal */
export const CreateJsonWebKeySetRequest$outboundSchema: z.ZodMiniType<
  CreateJsonWebKeySetRequest$Outbound,
  CreateJsonWebKeySetRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createJSONWebKeySetForm: CreateJSONWebKeySetForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createJSONWebKeySetForm: "CreateJSONWebKeySetForm",
    });
  }),
);

export function createJsonWebKeySetRequestToJSON(
  createJsonWebKeySetRequest: CreateJsonWebKeySetRequest,
): string {
  return JSON.stringify(
    CreateJsonWebKeySetRequest$outboundSchema.parse(createJsonWebKeySetRequest),
  );
}
